import React, { createContext, useContext, useState } from "react";


const ConfigContext = createContext({
    response: null,
    setResponse: () => { },
    configLoading: false,
    clearResponse: () => { },
});

export const useConfig = () => useContext(ConfigContext);

export const ConfigContextProvider = ({ children }) => {
    const [configData, setConfigData] = useState(null);
    const [configLoading, setConfigLoading] = useState(false);
    const clearResponse = () => {
        setConfigData(null);
    };


    return (
        <ConfigContext.Provider value={{ configData, setConfigData, clearResponse, setConfigLoading, configLoading }}>
            {children}
        </ConfigContext.Provider>
    );
};
